import { useState } from 'react'
import styles from './Calendar.module.css'

const Calendar = ({ startDate, endDate, selectingStart, onDateSelect }) => {
    const [currentDate, setCurrentDate] = useState(new Date())

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

    const dayNames = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']

    const getDaysInMonth = (date) => {
        const year = date.getFullYear()
        const month = date.getMonth()
        const firstDay = new Date(year, month, 1)
        const lastDay = new Date(year, month + 1, 0)
        const daysInMonth = lastDay.getDate()
        const startingDayOfWeek = firstDay.getDay()

        const days = []

        // Previous month's trailing days
        const prevMonth = new Date(year, month - 1, 0)
        const prevMonthDays = prevMonth.getDate()
        for (let i = startingDayOfWeek - 1; i >= 0; i--) {
            days.push({
                date: new Date(year, month - 1, prevMonthDays - i),
                isCurrentMonth: false,
            })
        }

        // Current month days
        for (let day = 1; day <= daysInMonth; day++) {
            days.push({
                date: new Date(year, month, day),
                isCurrentMonth: true,
            })
        }

        // Next month's leading days
        const totalCells = Math.ceil(days.length / 7) * 7
        let nextMonthDay = 1
        for (let i = days.length; i < totalCells; i++) {
            days.push({
                date: new Date(year, month + 1, nextMonthDay),
                isCurrentMonth: false,
            })
            nextMonthDay++
        }

        return days
    }

    const isSameDate = (date1, date2) => {
        if (!date1 || !date2) return false
        return date1.toDateString() === date2.toDateString()
    }

    const isInRange = (date) => {
        if (!startDate || !endDate) return false
        return date >= startDate && date <= endDate
    }

    const isRangeStart = (date) => {
        return startDate && isSameDate(date, startDate)
    }

    const isRangeEnd = (date) => {
        return endDate && isSameDate(date, endDate)
    }

    const handleDateClick = (date) => {
        onDateSelect(date)
    }

    const navigateMonth = (direction) => {
        setCurrentDate((prev) => {
            const newDate = new Date(prev)
            newDate.setMonth(prev.getMonth() + direction)
            return newDate
        })
    }

    const getNextMonthDate = () => {
        const nextMonth = new Date(currentDate)
        nextMonth.setMonth(currentDate.getMonth() + 1)
        return nextMonth
    }

    const renderMonth = (date, isSecondMonth = false) => {
        const days = getDaysInMonth(date)
        const monthYear = `${monthNames[date.getMonth()]} ${date.getFullYear()}`

        return (
            <div className={styles.monthContainer}>
                <div className={styles.monthHeader}>
                    {!isSecondMonth && (
                        <button className={styles.navButton} onClick={() => navigateMonth(-1)}>
                            ‹
                        </button>
                    )}
                    <div className={styles.monthTitle}>{monthYear}</div>
                    {isSecondMonth && (
                        <button className={styles.navButton} onClick={() => navigateMonth(1)}>
                            ›
                        </button>
                    )}
                </div>

                <div className={styles.weekdays}>
                    {dayNames.map((day) => (
                        <div key={day} className={styles.weekday}>
                            {day}
                        </div>
                    ))}
                </div>

                <div className={styles.daysGrid}>
                    {days.map((dayObj, index) => {
                        const { date, isCurrentMonth } = dayObj
                        const isToday = isSameDate(date, new Date())
                        const isSelected = isSameDate(date, startDate) || isSameDate(date, endDate)
                        const inRange = isInRange(date)
                        const rangeStart = isRangeStart(date)
                        const rangeEnd = isRangeEnd(date)

                        return (
                            <button
                                key={index}
                                className={`
                  ${styles.dayButton}
                  ${!isCurrentMonth ? styles.otherMonth : ''}
                  ${isToday ? styles.today : ''}
                  ${isSelected ? styles.selected : ''}
                  ${inRange ? styles.inRange : ''}
                  ${rangeStart ? styles.rangeStart : ''}
                  ${rangeEnd ? styles.rangeEnd : ''}
                `}
                                onClick={() => handleDateClick(date)}
                                disabled={!isCurrentMonth}>
                                {date.getDate()}
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    }

    return (
        <div className={styles.calendar}>
            <div className={styles.doubleMonth}>
                {renderMonth(currentDate)}
                {renderMonth(getNextMonthDate(), true)}
            </div>
        </div>
    )
}

export default Calendar
